import React from 'react';
import styles from './modesview.module.css';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';
import Dropdown from './inputs/Dropdown';
import {numberWithCommas, profileAPI, CDN_URI as MAIN_CDN_URI } from '../common/utilities';
import {modeData} from '../common/modes_data';
import { isNumber } from 'util';
import ReactImageFallback from "react-image-fallback";
import { Trans } from 'react-i18next';

export default class ModesView extends React.Component {

	constructor(props){
        super(props);
        
	    this.state = {
            outputList: []
            ,userData: this.props.userData
            ,userDataStats: null
            ,usn: this.props.usn
            ,gid: this.props.gid
            ,mode: null
            ,skillLevelsRequired: (this.props.gid && 'ZM' == this.props.gid) ? true : false
            ,modeList: []
            ,modeUniqueList: []
            ,skillLevels: []
            ,contentReady: false
            ,errorData: <div className={styles.text}><h5><Trans>Error: no data found</Trans></h5></div>
        }
        this.changeMode = this.changeMode.bind(this);
    }

    componentDidMount(){

        // get user data
        this.getUserModeData();
    }

    componentDidUpdate(prevProps, prevState){

        if(null !== this.state.modeUniqueList && null !== this.state.userData && null == this.state.userDataStats && !this.state.contentReady){

            // this will also be set to true on error cases in order to show something to the user
            this.setState({
                contentReady: true
            })
            //console.log('state', this.state.mode);
        }

        if(this.state.mode != prevState.mode && this.state.contentReady){
            this.getUserModeData();
            //console.log('mode ID changed to: ' + this.state.mode);
        }
    }

    /**
     * Each mode has various skill levels
     * Find all skill levels for the mode
     * Display buttons for users to get scores for various skill levels
     * 
     * @param {*} id 
     */
    getCurrentModeSkillLevels(id){

        var _this = this;
        var myName = this.state.modeList.filter(modes => modes.MODE_ID == id);

        //console.log(this.state.modeList);
        //console.log(this.state.modeUniqueList);
        //console.log('myName');
        //console.log(myName);

        //var modeLevelsList = this.state.modeList.filter(modes => modes.MODE_DISPLAY_NAME == myName[0].MODE_DISPLAY_NAME);

        var modeLevelsList = this.state.modeList.filter(function(modes) {

            if(myName && myName[0] && myName[0].MODE_DISPLAY_NAME){
                return modes.MODE_DISPLAY_NAME == myName[0].MODE_DISPLAY_NAME;
            }else{
                return null;
            }

        });

        var modeLevels = <Grid className={styles.levels} container spacing={1}>
                            {modeLevelsList.map(
                                    function(mode){
                                        var myStyle = (id == mode.MODE_ID) ? styles.button + ' ' + styles.active : styles.button;
                                        //var active = (id == mode.MODE_ID) ? ' active' : '';

                                        return  <Grid key={mode.MODE_ID} item xs={6}>
                                                    <span className={myStyle} id={mode.MODE_ID} onClick={() => _this.changeMode(mode.MODE_ID)}>
                                                        {mode.DIFICULTY_NAME}
                                                    </span>
                                                </Grid>
                                    }
                                )
                            }
                        </Grid>;

        //console.log(modeLevels);
        //alert(myName[0].MODE_DISPLAY_NAME);
        this.setState({
            skillLevels: modeLevels
        });
        //console.log('changing mode to: ' + myName[0].MODE_DISPLAY_NAME)
    }

    changeMode(id){

        //console.log('mode ID changed to: ' + id);
        this.setState({
            mode: id
        });

        //console.log(id)

        if(this.state.skillLevelsRequired){
            this.getCurrentModeSkillLevels(id);
        }
    }

    createModesDropDown(){

        return <Dropdown onChange={this.changeMode} options={this.state.modeUniqueList} />

    }

    getModesList(response){
        var _this = this;

        if(response.data){

            // we need to get the mode list and the user data

            //modeList
            if(response.data.APIresult && '000' == response.data.APIresult
               && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
               && !response.data.p_o_ErrDesc && response.data.dsProfileGameModeList
               && response.data.APImessage && 'OK' == response.data.APImessage){
    
                //console.log('SUCCESS: retrieved mode list data');
                //console.log(response.data.dsProfileGameModeList[0]);

                // we have to initialize stately mode to populate other states
                if(response.data.dsProfileGameModeList[0].MODE_ID && null == _this.state.mode){
                   //_this.initDisplay(response.data.dsProfileGameModeList[0].MODE_ID);

                   _this.setState({
                        mode: response.data.dsProfileGameModeList[0].MODE_ID
                    })
                }

                // Save the modeList, and, save another state modeUniqueList. 
                // When any mode is selected (from modeUniqueList), we'll check modeList for the corresponding difficulty levels

                // remove duplicates - duplicates are the same mode with different difficulties, which are selected outside of the <select> construct
                // save unique values in modeUniqueList

                //console.log('setting mode lists (all and unique)');

                var optionSelectObject = response.data.dsProfileGameModeList.filter((item, index, self) =>
                                                index === self.findIndex((t) => (
                                                    t.MODE_DISPLAY_NAME == item.MODE_DISPLAY_NAME 
                                                ))
                                        );
                // update the selection object to use properties 'value' and 'label' to use the Dropdown Component                                        
                for (var k in optionSelectObject){
                    optionSelectObject[k].value = optionSelectObject[k].MODE_ID;
                    optionSelectObject[k].label = optionSelectObject[k].MODE_DISPLAY_NAME;
                }

                //console.log(optionSelectObject);

                _this.setState({
                    modeList: response.data.dsProfileGameModeList
                    ,modeUniqueList : optionSelectObject
                  });
                // init skill levels
                //console.log('initialize skill levels');
                if(this.state.skillLevelsRequired){
                    _this.getCurrentModeSkillLevels(response.data.dsProfileGameModeList[0].MODE_ID);
                }
            }
        }
    }

    getUserModeData(){

        var apilink = profileAPI;

        var params = {};

        var _this = this;

        params.command = 'gamemode';
        params.usn = this.props.usn;
        params.gid = this.state.gid;
        params.mode = this.state.mode;
      
        axios.get(apilink, {params: params})
          .then(function(response){
      
            if(response.data){

                // don't update this list if I don't have to
                if(0 == _this.state.modeList.length){
                    _this.getModesList(response);
                }

                if(response.data.APIresult && '000' == response.data.APIresult
                   && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
                   && !response.data.p_o_ErrDesc && response.data.dsProfileGameModeDetails && response.data.dsProfileGameModeDetails[0]
                   && response.data.APImessage && 'OK' == response.data.APImessage){
        
                    //console.log('SUCCESS: retrieved user mode data');
                    //console.log(response.data.dsProfileGameModeDetails[0]);

                  _this.setState({
                      userData: (response.data.dsProfileGameModeDetails[0])
                  });
                  _this.getUserDetails();

                }else{
                  //console.log('FAIL: could not retrieve mode data due to \'not OK\' repsponse');
                    _this.setState({
                        userDataStats: _this.state.errorData
                        ,contentReady: true
                    });
                }
              }else{
                //console.log('FAIL: could not retrieve mode details');
                  _this.setState({
                    userDataStats: _this.state.errorData
                    ,contentReady: true
                  });
              }
          })
          .catch(function (error){
                //console.log('FAIL: could not retrieve mode details');
                _this.setState({
                    userDataStats: _this.state.errorData
                    ,contentReady: true
                });
          });
      }

    getUserDetails(){

        // statistics are sent like so:

            //    "STAT01_VALUE": 276,
            //    "STAT01_NAME": "KILLS",        
        // So we'll have to loop through the properties and try to find as many statistics as we can.

        var toBeDeterminedText = 'TBD';

        var maxStats = 9;      // arbitrary limit but we should proceed in order (and avoid num_pad)
        const prefix = "STAT0";
        const valueSuffix = "_VALUE";
        const nameSuffix = "_NAME";

        var myStat,myVal = null;

        var list = [];
        var stats = [];
        var vals = [];
        for(var i = 1; i<= maxStats; i++){

            myStat = prefix + i + nameSuffix;
            myVal = prefix + i + valueSuffix;

            //console.log('looking for ' + myStat);

            var myValue = (isNumber(this.state.userData[myVal]))
                                ? numberWithCommas(parseInt(this.state.userData[myVal],10))
                                : this.state.userData[myVal];

            // Live Team asked DB Team to return 'to be determined' when there is no data. It will be represented by '-1'
            if(-1 == myValue){
                myValue = toBeDeterminedText;
            }

            if(this.state.userData[myStat] && '-' !== this.state.userData[myStat]){

                //console.log('found: ' + this.state.userData[myStat], 'found: ' + this.state.userData[myVal]);

                list.push(
                    <Grid item xs={12} key={i} className={styles.statValueFlexContainer}>
                        <h5>{this.state.userData[myStat]}</h5>
                        <h3>{myValue}</h3>
                    </Grid>
                )
            }
        }

        this.setState({
            userDataStats: list
        });
    }

    myModesSkeleton()
    {
        return (
            <div>
                <Skeleton height={6} width="100%" />
                <Skeleton variant="rect" width="250px" height="100px" />
                <Grid item xs={12}>
                    <Skeleton height={6} width="80%" />
                </Grid>
                <Grid item xs={12}>
                    <Skeleton height={6} width="80%" />
                </Grid>
            </div>
        );
    }

    createModesImg(){

        var CDN_URI = `${MAIN_CDN_URI}imgs/modes/`;
        //var CDN_URI  = "https://crossfire.z8games.com/assets/imgs/modes/";
        var imgSrcID = (this.state.mode) ? this.state.mode : 1;
		
		var fallbackImage = `${MAIN_CDN_URI}imgs/modes/mode_missing.jpg`;
		
		var modeImg = (modeData && modeData[imgSrcID] && modeData[imgSrcID].IMG) ? CDN_URI + modeData[imgSrcID].IMG : fallbackImage;
		

        return (
            <ReactImageFallback
                src={modeImg}
                fallbackImage={fallbackImage}
                alt="mode img"
            />
        );          
    }

    render (){

        if(this.state.contentReady){

            return (
                <div className={styles.modesView}>

                    {this.createModesDropDown()}

                    <div className={styles.modeImg}>
                        {this.createModesImg()}
                    </div>

                    {this.state.skillLevels}

                    <div className={styles.text}>

                        {this.state.userDataStats
                            ?
                                this.state.userDataStats
                            : 
                                this.myModesSkeleton()
                        }

                    </div> 
                </div>
            );

        }else{

            // skeleton

            return(

                <div className={styles.text}>

                    {this.myModesSkeleton()}

                </div>
            );
        }
    }
}